var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYourtrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 2500,
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "65.797%",
    y1: "66.687%",
    x2: "2.105%",
    y2: "5.574%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#905CFB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A554E6",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D641B5",
    offset: "25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F43597",
    offset: "39%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF318C",
    offset: "47%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.61 98.195c42.346-38.629 89.39-81.692 90.752-83.054a63.493 63.493 0 0 1 6.8-6c17.868-13.169 42.523-12 59.066 2.8 16.542 14.802 20.435 39.176 9.326 58.393a43.855 43.855 0 0 1-7.4 9.6c-9.398 9.398-45.394 47.594-45.394 47.594s47.194 45.394 47.994 45.994c11.696 9.369 14.684 25.931 7 38.796a30.896 30.896 0 0 1-20.998 14.398c-2.598.459-36.915-32.57-74.812-59.294-23.958 26.878-71.622 80.332-71.771 80.332-20.238 14.158-44.995 6.36-56.194.2a56.433 56.433 0 0 1-9.399-90.59c6.6-5.999 34.596-31.396 64.993-59.193l.038.024z",
    fill: "#0CB0F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M167.802 111.988a36.355 36.355 0 0 0-13.869-23.61L80.22 13.785a46.977 46.977 0 1 0-60.926 71.148l88.984 62.129a37.157 37.157 0 0 0 59.524-35.073z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.855 48.763h159.382v159.382H47.855z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.992 175.87h58.374v10.56H63.992v-10.56zm21.317-63.952L58.414 69.682h17.93L93.08 97.773l16.935-28.09h17.492l-26.896 42.036v27.892H85.27v-27.693h.04zm65.746-28.09h-21.318V69.681h57.776v14.145h-21.118v55.585h-15.34V83.827z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourtrack);
export default __webpack_public_path__ + "static/media/yourtrack.349685c87b7310b4ef1509849324d5da.svg";
export { ForwardRef as ReactComponent };